import React from 'react';
import PropTypes from 'prop-types';
import UpcomingWebinars from 'containers/Dashboard/UpcomingWebinars/UpcomingWebinars'
import { Link } from 'react-router';
import _ from 'lodash';

function Landing({
  webinars,
  nextPage,
  page,
  count
}) {
  return (
  <div>
    <main className="bg_white site--width">
      <div className="bg_landing_main">
        <div className="bg_landing">
          <img src="/assets/img/logo.png" alt="logo" />
          <h2>LEARNING MADE EASY</h2>
          <h5>ONLINE WEBINARS & LIVE STREAMING SERVICE</h5>
          <Link style={{zIndex: '5'}} to='/users/sign_in' className="enter_med">ENTER MEDCAFE</Link>
          <div className="bg_icons_landing"></div>
          <img className="img_mackbook" src="/assets/img/landing-top-notebook_new.png" alt="mackbook" />
        </div>
        <div className="container_landing">
          <div className="bg_light">
          </div>
        </div>
      </div>
      <div className="landing_info">
        <div className="landing_section_info">
          <img src="/assets/img/cpd-hours.png" alt="image" />
          <h3>CPD</h3>
          <p>Accredited webinars & live streams all in one place</p>
        </div>
        <div className="landing_section_info">
          <img src="/assets/img/free.png" alt="image" />
          <h3>100% Free</h3>
          <p>All webinars & live streams are free of charge</p>
        </div>
        <div className="landing_section_info">
          <img src="/assets/img/desktop.png" alt="image" />
          <h3>Anywhere & Anytime </h3>
          <p>Available on desktop, tablet & mobile</p>
        </div>
        <div className="landing_section_info">
          <img src="/assets/img/local.png" alt="image" />
          <h3>Designed by GPs</h3>
          <p>For doctors & healthcare professionals</p>
        </div>
      </div>
        <UpcomingWebinars
          webinars={webinars.filter(el => !_.includes([91, 94], el.id))}
          nextPage={() => (nextPage(UPCOMING_WEBINARS))}
          page={page.upcoming}
          count={count}
        />
        {/*
        <div className="container_testimonials">
          <h5>TESTIMONIALS</h5>
          <div className="container_section_testimonials">
            <div className="section_testimonials">
              <img src="/assets/img/testimonials/ava.png" alt="photo" />
              <p className="section_testimonials_name">JORDAN MANSON</p>
              <p className="section_testimonials_position">GP, Galway</p>
              <p className="section_testimonials_description">
                Chances are unless you are very lucky you will go thru many different relationships before you find your special someone. Finding your sole mate is like gambling.
              </p>
            </div>
            <div className="section_testimonials">
              <img src="/assets/img/testimonials/ava2.png" alt="photo" />
              <p className="section_testimonials_name">JORDAN MANSON</p>
              <p className="section_testimonials_position">GP, Galway</p>
              <p className="section_testimonials_description">
                Chances are unless you are very lucky you will go thru many different relationships before you find your special someone. Finding your sole mate is like gambling.
              </p>
            </div>
            <div className="section_testimonials">
              <img src="/assets/img/testimonials/ava3.png" alt="photo" />
              <p className="section_testimonials_name">JORDAN MANSON</p>
              <p className="section_testimonials_position">GP, Galway</p>
              <p className="section_testimonials_description">
                Chances are unless you are very lucky you will go thru many different relationships before you find your special someone. Finding your sole mate is like gambling.
              </p>
            </div>
          </div>
          <button className="discover_more" type="button" name="button">DISCOVER MORE</button>
        </div>
      */}
    </main>
    <footer className="footer_landing">
      <div className="footer_svg">
      </div>
    </footer>
  </div>
  );
}

Landing.defaultProps = {};

Landing.propTypes = {};

export default Landing;



/** WEBPACK FOOTER **
 ** ./src/components/Landing/Landing.jsx
 **/